//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { useHistory } from "react-router-dom";
import * as moment from "moment";


// custom pages
import Table from "components/Table/Table";
import redirectionlinks from "apis/RedirectionLinks/redirectionlinks"
import { styles } from "./styles";
import Loader from "components/Loader/Loader";
import VisibilityIcon from "@material-ui/icons/Visibility";
import HistoryTable from "components/Table/History/HistoryTable";

// material-ui
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import InputAdornment from '@material-ui/core/InputAdornment';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import searchIcon from 'assets/img/Search_Icon.png';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import useDebounce from 'helpers/useDebounce';
import ThriveSignatureRequests from 'apis/ThriveSignatureRequest/ThriveSignatureRequest';
import PreviewToPdf from "./Preview";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import { pdf } from '@react-pdf/renderer';
import ThriveSignaturePDF from './ThriveSignaturePDF';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Modal, Backdrop, Fade } from '@material-ui/core';

import { useTranslation } from 'react-i18next';




const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      marginTop: 0,
    },
  },
})(TextField);

const formFields = [
  { label: "Henry Schein Account Number", key: "henry_schein_account_number" },
  { label: "Title", key: "title" },
  { label: "Practice Owner Name", key: "practice_owner_name" },
  { label: "Point of Contact", key: "point_of_contact" },
  { label: "Office Number", key: "office_number" },
  { label: "Preferred Contact Number", key: "preferred_contact_number" },
  { label: "Email", key: "email" },
  { label: "Practice Name", key: "practice_name" },
  { label: "Street Address", key: "street_address" },
  { label: "City", key: "city" },
  { label: "State", key: "state" },
  { label: "Zip Code", key: "zipcode" },
  { label: "Select Subscription Plan", key: "subscription_plan" },
];

export default function ThriveSignatureRequest(props) {
  const { state, dispatch } = useContext(context);
  const { getsignature, searchAPI } = ThriveSignatureRequests();

  const history = useHistory();
  const classes = styles();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [res, setRes] = useState(false);
  const [open, setOpen] = useState(false);
  const [previewData, setPreviewData] = useState({});

  const [isActive, setIsActive] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [openModal, setOpenModal] = useState(false);
     const [imageType, setImageType] = useState('');
     const { t, i18n } = useTranslation();


  let searchBounceValues = useDebounce(() => {
    return searchValue === '' ? '' : searchValue;
  });
  // const { clearSearch } = states;
  // For bread-crumbs
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "ADMIN", "RESPONSE"] });
  }, []);

  const [states, setstates] = useState({ historyLoader: false, clearSearch: false });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const handlepdfClose = () => {
    setOpenModal(false);
}

  const { historyLoader } = states;

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };
  useEffect(() => {
    if (!states?.clearSearch) {
      if (searchBounceValues && searchBounceValues.length > 0) {
        handleSearch();
      }
      else {
        handleGet();
      }
    }
    else {
      setStates({ clearSearch: false });
    }
  }, [searchBounceValues, offset, isActive]);

  // handling api calls
  useEffect(() => {
    handleGet();
  }, [offset, isActive]);

  // get api func
  const handleGet = async () => {
    try {
      dispatch({ type: 'SET_LOADING', payload: true })
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10
      };
      let res = await getsignature(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setRes(true);
      }
      dispatch({ type: 'SET_LOADING', payload: false })
    }
    catch (e) {
      console.log({ e });
    }
  };
  async function handleSearch() {
    try {

      dispatch({ type: 'SET_LOADING', payload: true })

      let values;
      values = {
        search: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      // setResponse({ ...response, filter: false });
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setRes(true);
        dispatch({ type: 'SET_LOADING', payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  

  // const handleDownload = async (rowData) => {
  //   const formattedData = {
  //     ...rowData,
  //     practice_owner_name: `${rowData.practice_owner_first_name} ${rowData.practice_owner_last_name}`,
  //     point_of_contact: `${rowData.point_of_contact_first_name} ${rowData.point_of_contact_last_name}`,
  //     signature: rowData.url,
  //     thrivesignatureLink: rowData.thrivesignatureLink,
  //     thrivesignaturetermconditionLink: rowData.thrivesignaturetermconditionLink,
  //     signaturebase64 : rowData.signature_sign_base64
  //   };

  //   const blob = await pdf(
  //     <ThriveSignaturePDF formData={formattedData} formFields={formFields} />
  //   ).toBlob();

  //   const blobUrl = URL.createObjectURL(blob);
  //   const link = document.createElement('a');
  //   link.href = blobUrl;
  //   link.download = 'Signature Form.pdf';
  //   link.click();

  //   URL.revokeObjectURL(blobUrl);
  // };

  

//   const handlepdfClose = () => {
//     setOpenModal(false);
// }



  

  const handleClose = () => {
    setOpen(false);
  }
  const blockInvalidChar = e => ['.', '-', '+', 'ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault();
  const getPlanName = (plan) => {
    if (!plan) return "-";
    const index = plan.indexOf(":");
    if (index === -1) {
      // If no colon, fallback to first two words
      return plan.split(" ").slice(0, 2).join(" ");
    }
    return plan.substring(0, index).trim();
  };
  
  return (
    <React.Fragment>
      <Grid container className={classes.root}>
        <Grid item xs={12} sm={12} lg={12} style={{ position: 'relative' }}>
          {/* <div style={{ flex: 0.99 }}> */}
          <CssTextField
            placeholder={'Search for Ship To'}
            type={"text"}
            variant="outlined"
            onKeyDown={blockInvalidChar}
            className={classes.searchInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {searchValue.length > 0 ? (
                    <CloseOutlinedIcon
                      className={classes.searchInputIcon}
                      onClick={() => {
                        setSearchValue("");
                        setOffset(1);
                        handleGet();
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt=""
                      width="20px"
                      className={classes.searchInputIcon}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setOffset(1);
              if (e.target.value.length == 0) {
                handleGet();
              }
            }}
            onClick={() => {
              setOffset(offset);
            }}
          />
          {/* </div> */}

        </Grid>
      </Grid>
      
      <Loader loading={state.loading} top="15%">
        <Grid className={classes.tableDownInResponsive}>
          <Grid item xs={12} sm={12} lg={12}>
          {res ? (
        data && data.length > 0 ? (
        <Table
        headings={[
        "S.No",
        "Ship To",
        "Name",
        "Email",
        "Submitted Date",
        "Payment Plan",
        "Status",
        "Signature Document",
       
      ]}
      data={data.map((d, i) => [
        ((offset - 1) * 10) + (i + 1),
        d?.henry_schein_account_number,
        d?.practice_name,
        d?.email,
        <span>{d?.created_at || d?.createdAt ? moment(d.created_at || d.createdAt).format("YYYY-MM-DD") : "-"}</span>,
        <span>{getPlanName(d?.subscription_plan)}</span>,
        d?.status,
        // <span 
        //   style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
        //   onClick={() => {
        //     setOpen(true);
        //     setPreviewData({
        //       ...d,
        //       practice_owner_name: `${d.practice_owner_first_name} ${d.practice_owner_last_name}`,
        //       point_of_contact: `${d.point_of_contact_first_name} ${d.point_of_contact_last_name}`,
        //       signature: d.url,
        //       thrivesignatureLink: d.thrivesignatureLink,
        //       thrivesignaturetermconditionLink: d.thrivesignaturetermconditionLink,
        //       signaturebase64 : d.signature_sign_base64
        //     });
        //   }}
        // >
        //   View
        // </span>,

                    <a
              key={i}
              style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
              onClick={() => {
                setImageType(d?.url);
                setOpenModal(true);
              }}
            >
              {t("View")}
            </a>,


    //   <IconButton
    //   aria-label="download"
    //   onClick={() => {
    //     const updatedData = {
    //       ...d,
    //       practice_owner_name: `${d.practice_owner_first_name} ${d.practice_owner_last_name}`,
    //       point_of_contact: `${d.point_of_contact_first_name} ${d.point_of_contact_last_name}`,
    //       signature: d.url,
    //       thrivesignatureLink: d.thrivesignatureLink,
    //       thrivesignaturetermconditionLink: d.thrivesignaturetermconditionLink,
    //       signaturebase64 : d.signature_sign_base64
    //     };

    //     setPreviewData(updatedData); // Optional
    //     handleDownload(d);           // Actual download function
    //   }}
    // >
    //   <GetAppIcon />
    // </IconButton>
    


      ])}
      offset={offset}
      count={
        (count / 10) % 1 === 0
          ? Math.floor(count / 10)
          : Math.floor(count / 10 + 1)
      }
      handlePagination={handlePagination}
    />
  ) : (
    // Show folder icon and message when no data
    <div className={classes.emptyDataText}>
      <div>
        <FolderOpenIcon className={classes.emptyDataIcon} />
      </div>
      <div className={classes.errorMsg}>
        <b>No Data Found</b>
      </div>
    </div>
  )
) : (
  <Loader Loading={true} top={"15%"} />
)}

{openModal && (
                                    <Modal
                                      className={classes.modal}
                                      open={openModal}
                                      onClose={handlepdfClose}
                                      closeAfterTransition
                                      BackdropComponent={Backdrop}
                                      BackdropProps={{
                                        timeout: 300,
                                      }}
                                    >
                                      <Fade in={openModal} timeout={300} className={classes.img}>
                                        
                                          <iframe src={imageType} width='800' height='600'></iframe>
                                       
                                      </Fade>
                                    </Modal>
                                  )}

          </Grid>
        </Grid>
      </Loader>
      <PreviewToPdf open={open} formFields={formFields} formData={previewData} onClose={handleClose} />
    </React.Fragment>
  );
}
